module.exports = __webpack_public_path__ + "img/Time_Zone.4002a950.svg";